import { connect } from "react-redux";
import PensionIntegrationsModal from "./PensionIntegrationsModal";
import { format } from "date-fns";
import { Link } from "react-router-dom";

const EmployeePensionRow = ({
	name,
	agreement,
	occupation,
	pensionPlan,
	pensionIntegrations,
	integrationLinks,
	status,
	group,
	currency,
	enrolmentDate,
	hasMultiRole,
}) => {
	return (
		<tr>
			<td></td>
			<td>
				{/* Link to agreement pension page*/}
				<Link
					to={`/organisation/people/${agreement}${hasMultiRole ? `/roles/${pensionPlan?.occupation ?? occupation}` : ``}/pension`}
					style={{ paddingLeft: "4px", color: "#ea611c" }}
				>
					{name}
				</Link>
			</td>
			<td className="pl-12">
				<span style={{ paddingLeft: "6px" }}>
					{status}
					{status === "Postponed" ? " until " : " on "}
					<span style={{ fontWeight: 600 }}>{format(enrolmentDate, "dd/MM/yyyy")}</span>
				</span>
			</td>
			<td>
				{["Postponed", "Opted Out"].includes(status) ? null : (
					<span style={{ paddingLeft: "18px" }}>{group?.name}</span>
				)}
			</td>
			<td>
				{["Postponed", "Opted Out"].includes(status)
					? null
					: `${!pensionPlan?.employeePercentage ? currency : ""}${pensionPlan?.employeeContribution}${pensionPlan?.employeePercentage ? "%" : ""}`}
			</td>
			<td>
				{["Postponed", "Opted Out"].includes(status)
					? null
					: `${!pensionPlan?.employerPercentage ? currency : ""}${pensionPlan?.employerContribution}${pensionPlan?.employerPercentage ? "%" : ""}`}
			</td>
			{pensionIntegrations?.length > 0 && (
				<td textAlign="right">
					{integrationLinks?.length > 0 && <PensionIntegrationsModal links={integrationLinks} />}
				</td>
			)}
			<td></td>
		</tr>
	);
};

const mapStateToProps = (state) => {

	return {
		hasMultiRole: state.company?.hasMultiRole,
	};
};

const mapDispatchToProps = (dispatch) => {
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeePensionRow);
